import { EMBED_MESSAGE, SSO_AUTH_REQUIRED } from '~/api/shared/_constants.js';

export default defineNuxtRouteMiddleware(async(to) => {
  if (import.meta.client) {
    if (useEmbed().value) {
      if (!useAuthStore().isLoggedIn) {
        const hash = new URLSearchParams(window.location.hash.slice(1));
        const ssoToken = hash.get('t');
        if (ssoToken) {
          // Fresh first load (or identity change) — exchange and stash.
          history.replaceState(null, '', window.location.pathname + window.location.search);
          console.log('[embed] exchanging SSO token');
          const response = await useApi.post('/distributor-sso/exchange', { body: { token: ssoToken } })
            .catch((err) => {
              console.error('[embed] SSO exchange failed:', err?.response?._data || err);
              return null;
            });
          if (response) {
            console.log('[embed] SSO exchange ok, setting auth');
            useAuthStore().setAuth(response);
            try {
              window.sessionStorage.setItem('envelope-embed-auth', JSON.stringify(response));
            } catch { /* sessionStorage unavailable — non-fatal */ }
          } else {
            window.sessionStorage.removeItem('envelope-embed-auth');
            useEmbedAuthFailed().value = true;
            postToEmbedParent({ type: EMBED_MESSAGE.AUTH_FAILED });
          }
        } else {
          // No hash — try restoring from a previous successful exchange.
          // Survives iframe reloads (Vite HMR, manual refresh, parent re-mount)
          // after `history.replaceState` already stripped the hash.
          let stashed = null;
          try {
            stashed = window.sessionStorage.getItem('envelope-embed-auth');
          } catch { /* sessionStorage unavailable */ }
          if (stashed) {
            try {
              useAuthStore().setAuth(JSON.parse(stashed));
              return;
            } catch {
              window.sessionStorage.removeItem('envelope-embed-auth');
            }
          }
          console.warn('[embed] no #t=<token> in URL hash — iframe cannot authenticate');
          useEmbedAuthFailed().value = true;
          postToEmbedParent({ type: EMBED_MESSAGE.AUTH_FAILED });
        }
      }
      return;
    }

    let isLoggedIn = useAuthStore().isLoggedIn;
    const config = useRuntimeConfig();

    if (useCookie('token').value && !isLoggedIn) {
      await useAuthStore().fetchUser();
      isLoggedIn = useAuthStore().isLoggedIn;
    }

    if (useError().value) { // for error page
      return abortNavigation();
    }

    if (to.meta.public && isLoggedIn && to.meta?.layout !== 'page' && to.meta?.layout !== 'guest-app' && to.meta?.layout !== 'quote') {
      const { token, ...query } = to.query;
      return navigateTo({
        path: '/',
        query,
      });
    }
    if (!to.meta.public && !isLoggedIn) {
      const distributorConfig = useDistributorConfig().value;

      if (distributorConfig?.sso?.mode === SSO_AUTH_REQUIRED && distributorConfig?.sso?.redirectUrl) {
        return navigateTo(distributorConfig.sso.redirectUrl, { external: true });
      }

      if (to.path === '/' && config.public.websiteUrl && !isDistributorDomain(globalThis.location?.hostname)) {
        const queryString = new URLSearchParams(to.query).toString();
        return navigateTo(`${config.public.websiteUrl}${queryString ? `?${queryString}` : ''}`, { external: true });
      }

      window?.sessionStorage?.setItem?.('redirectedFromPath', to.path);
      return navigateTo('/login');
    }
  }
});
